import { render, staticRenderFns } from "./DeleteModel.vue?vue&type=template&id=712584e2&scoped=true"
import script from "./DeleteModel.vue?vue&type=script&lang=js"
export * from "./DeleteModel.vue?vue&type=script&lang=js"
import style0 from "./DeleteModel.vue?vue&type=style&index=0&id=712584e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712584e2",
  null
  
)

export default component.exports